import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const onPasswordPage = state.url.startsWith('/account/password');

  if (!auth.ready()) {
    await auth.loadMe();
  }

  if (!auth.user()) {
    await router.navigateByUrl('/login');
    return false;
  }

  if (auth.authenticationMode() === 'zoho' && onPasswordPage) {
    await router.navigateByUrl('/reservations');
    return false;
  }

  if (auth.user()?.mustChangePassword && !onPasswordPage) {
    await router.navigateByUrl('/account/password?required=1');
    return false;
  }

  return true;
};
